import { FC } from 'react';

import VideoModal from 'src/components/common/modal/videoModal';

const InternalDocumentTutorialModalModal: FC = () => (
    <VideoModal videoUrl="https://www.youtube.com/watch?v=Y79E_hGta_w" />
);

export default InternalDocumentTutorialModalModal;
